import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import App from "./App";
import { ContextProvider } from "./contexts/ContextProvider"

// Crearea unui root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Utilizarea metodei render pe obiectul root
root.render(
    <React.StrictMode>
        <ContextProvider>
            <Router>
                <App />
            </Router>
        </ContextProvider>
    </React.StrictMode>
);